module.exports = __webpack_public_path__ + "img/hands.3c5464cd.png";